export default {
  getKey(o) {
    return Object.keys(o)[0];
  },
  getEntry(o) {
    return Object.entries(o)[0];
  },
};
